import React, { useState } from 'react';
import { STAGES } from './crmConstants';
import { LeadCard, ActionBadges, NextTaskChip } from './LeadCard';
import { stageOf, fmtDate } from './crmConstants';

const Column = ({ stage, leads, onOpen, onDropLead }) => {
  const [over, setOver] = useState(false);
  return (
    <div
      onDragOver={(e) => { e.preventDefault(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); const id = e.dataTransfer.getData('text/lead-id'); if (id) onDropLead(id, stage.id); }}
      className={`w-64 flex-shrink-0 rounded-2xl border bg-slate-900/60 flex flex-col max-h-[70vh] transition-colors ${over ? 'border-amber-400 bg-amber-500/5' : 'border-slate-800'}`}
      data-testid={`kanban-col-${stage.id}`}
    >
      <div className="px-3 py-2.5 flex items-center gap-2 border-b border-slate-800">
        <span className={`w-2.5 h-2.5 rounded-full ${stage.color}`} />
        <span className="text-sm font-semibold text-white">{stage.label}</span>
        <span className="ml-auto text-xs text-slate-400" data-testid={`kanban-count-${stage.id}`}>{leads.length}</span>
      </div>
      <div className="p-2 space-y-2 overflow-y-auto flex-1">
        {leads.map((l) => <LeadCard key={l.id} lead={l} onOpen={onOpen} draggable />)}
        {!leads.length && <p className="text-xs text-slate-600 text-center py-6">Trascina qui un lead</p>}
      </div>
    </div>
  );
};

export const KanbanBoard = ({ leads, onOpen, onMove }) => (
  <div className="flex gap-3 overflow-x-auto pb-3" data-testid="crm-kanban">
    {STAGES.map((s) => (
      <Column key={s.id} stage={s} leads={leads.filter((l) => l.status === s.id)} onOpen={onOpen} onDropLead={onMove} />
    ))}
  </div>
);

export const LeadList = ({ leads, onOpen }) => (
  <div className="rounded-2xl border border-slate-800 overflow-hidden" data-testid="crm-list">
    <table className="w-full text-sm">
      <thead className="bg-slate-800/80 text-slate-400 text-xs uppercase tracking-wider">
        <tr>
          <th className="text-left px-4 py-2.5">Lead</th>
          <th className="text-left px-4 py-2.5">Fase</th>
          <th className="text-left px-4 py-2.5">Azioni fatte</th>
          <th className="text-left px-4 py-2.5">Prossima azione</th>
          <th className="text-left px-4 py-2.5 hidden lg:table-cell">Responsabile</th>
          <th className="text-left px-4 py-2.5 hidden md:table-cell">Creato</th>
        </tr>
      </thead>
      <tbody>
        {leads.map((l) => {
          const st = stageOf(l.status);
          return (
            <tr key={l.id} onClick={() => onOpen(l)} className="border-t border-slate-800 hover:bg-slate-800/50 cursor-pointer" data-testid={`lead-row-${l.id}`}>
              <td className="px-4 py-3"><p className="text-white font-medium">{l.name}</p><p className="text-xs text-slate-400">{l.email}</p></td>
              <td className="px-4 py-3"><span className={`inline-flex items-center gap-1.5 text-xs ${st.text}`}><span className={`w-2 h-2 rounded-full ${st.color}`} />{st.label}</span></td>
              <td className="px-4 py-3"><ActionBadges done={l.actions_done} testIdPrefix={`row-${l.id}`} /></td>
              <td className="px-4 py-3"><NextTaskChip lead={l} /></td>
              <td className="px-4 py-3 hidden lg:table-cell text-slate-300 text-xs">{l.owner_name || '—'}</td>
              <td className="px-4 py-3 hidden md:table-cell text-slate-400 text-xs">{fmtDate(l.created_at, false)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
    {!leads.length && <p className="text-center text-slate-500 py-10">Nessun lead trovato</p>}
  </div>
);
